interface IContextMenuHeader {
  headerText: string;
  iconCssClass?: string;
}

interface IContextMenuOption {
  optionText: string;
  iconCssClass?: string;
  optionClass?: string;
  order?: number;
  menuOptionSelectedCallback?: () => void;
  isDisabled?: boolean;
}

class ContextMenuConfiguration {
  constructor(public readonly menuHeader: IContextMenuHeader, public readonly menuOptions: IContextMenuOption[]) {
  }
}

const OpenContextMenuEventName = 'openContextMenu';

export { ContextMenuConfiguration, IContextMenuHeader, IContextMenuOption, OpenContextMenuEventName };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/tombola-context-menu/context-menu-configuration.ts